import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-graphics',
  templateUrl: './graphics.component.html',
  styleUrl: './graphics.component.scss'
})
export class GraphicsComponent {
  @Input() informationColor = 0;
  @Input() informationNum = 0;
  @Input() informationScore = 0;
  @Input() reputationColor = 0;
  @Input() reputationNum = 0;
  @Input() reputationScore = 0;
  @Input() trustColor = 0;
  @Input() trustNum = 0;
  @Input() trustScore = 0;
}
